import Layout from "@/admin/js/layout/index.vue";

const pumpProjectsRoutes = {
    name: 'pump',
    path: '/pump',
    component: Layout,
    meta: { title: 'Базы для прокачки', noCache: false },
    redirect: '/pump/projects',

    children: [
        {
            name: 'pump-projects-index',
            path: 'projects',
            component: () => import('@/admin/js/views/projects-pump/index'), // Новый компонент с информацией о базах
            meta: { title: 'Текущий тариф' },
        },
        {
            name: 'pump-projects-settings',
            path: 'projects/settings',
            component: () => import('@/admin/js/views/projects-pump/settingsPage'), // Настройки
            meta: { title: 'Настройки баз' },
        },
        {
            name: 'pump-project-create',
            path: 'projects/settings/create',
            component: () => import('@/admin/js/views/projects-pump/create'),
            meta: { title: 'Создать базу' }
        },
        {
            name: 'pump-projects-statistics',
            path: 'projects/statistics',
            component: () => import('@/admin/js/views/projects-pump/statisticPage'), // Статистика
            meta: { title: 'Статистика' },
        },
        {
            name: 'pump-projects-pricing',
            path: 'projects/tariffs',
            component: () => import('@/admin/js/views/projects-pump/tariffPage'), // Тарифы
            meta: { title: 'Тарифы' },
        },
        {
            name: 'pump-project-show',
            path: 'projects/:api_key/:tab?',
            component: () => import('@/admin/js/views/projects-pump/show'),
            meta: { title: 'Детали' },
            beforeEnter(to, from, next) {
                // Если параметр `tab` отсутствует, перенаправляем на вкладку `link`
                if (!to.params.tab) {
                    next({ ...to, params: { ...to.params, tab: 'link' } });
                } else {
                    next();
                }
            },
        }
    ],
};

export default pumpProjectsRoutes;
